import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import Tour from "~/models/Tour";
import StripeConnectStore from "~/stores/StripeConnectStore";
import CustomerPaymentStore from "~/stores/CustomerPaymentStore";
import RansomPayment from "./RansomPayment";
import "../../../styles/RansomPayment.less";

@observer
class TourRansomStripeProvider extends Component {
  render() {
    const {
      tour,
      open,
      successRedirectUrl,
      onCancel,
      stripeConnectStore,
      customerPaymentStore,
      stripePromise,
    } = this.props;

    if (tour.clientFacingStatus !== "awaiting_payment") {
      return null;
    }

    if (!open) {
      return null;
    }

    const { isLoading: stripeConnectStoreIsLoading, stripeConnect } = stripeConnectStore;
    const { isLoading: customerPaymentStoreIsLoading, customerPayments } = customerPaymentStore;

    if (stripeConnectStoreIsLoading || stripePromise === null || customerPaymentStoreIsLoading) {
      return <LoadingWrapper loading />;
    }

    return (
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ stripe, elements }) => (
            <RansomPayment
              {...this.props}
              successRedirectUrl={successRedirectUrl}
              stripe={stripe}
              elements={elements}
              stripeConnect={stripeConnect}
              customerPayment={customerPayments[0]}
              onPay={(customerPaymentId, data) => customerPaymentStore.pay(customerPaymentId, data)}
              onCancel={onCancel}
            />
          )}
        </ElementsConsumer>
      </Elements>
    );
  }
}

TourRansomStripeProvider.propTypes = {
  tour: PropTypes.instanceOf(Tour).isRequired,
  // we don't show the Ransom modal open by default because we want it to always mount and fetch the necessary
  // data. Otherwise, if we mount e.g upon an external button click, the user will see a spinner while this
  // component is loading. In other words, by leveraging "open" we implement a "background fetch".
  open: PropTypes.bool,
  successRedirectUrl: PropTypes.string.isRequired,
  showError: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  stripeConnectStore: PropTypes.instanceOf(StripeConnectStore).isRequired,
  customerPaymentStore: PropTypes.instanceOf(CustomerPaymentStore).isRequired,
  stripePromise: PropTypes.shape({
    then: PropTypes.func.isRequired,
    catch: PropTypes.func.isRequired,
  }),
};

export default withTranslation()(TourRansomStripeProvider);
